import { ViewmodelAgreement } from '@acordocertobr/reneg-offers-hub';

export const mockAgreementDetail: ViewmodelAgreement = {
  id: 25855001,
  uuid: '550e8400-e29b-41d4-a716-446655440001',
  status: 'ACTIVE',
  createdAt: '2025-09-09T03:00:00.000Z',
  contract: '020250909',
  product: 'Cartão de Crédito',
  value: 2000.0,
  installmentsNumber: 5,
  hasMultipleBills: false,
  isOnExternalManagement: false,
  hasTerms: true,
  isCancellable: true,
  creditor: {
    slug: 'acordocerto',
    name: 'AcordoCerto',
    logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/e3835fe636/acordo-certo.svg',
    systemSlug: 'acordocerto',
  },
  paymentMethods: {
    firstInstallment: 'BILLET',
    default: 'BILLET',
  },
  installments: [
    {
      id: 8817700574,
      uuid: 'detail-billet-inst-001',
      status: 'AVAILABLE',
      paymentMethod: 'BILLET',
      number: 1,
      maxPaymentDate: '2025-09-12T03:00:00.000Z',
      dueDate: '2025-09-12T03:00:00.000Z',
      value: 400.0,
      hidePaymentDueDate: false,
      isCurrent: true,
      isFirstUnpaid: true,
      isNext: false,
    },
    {
      id: 8817700575,
      uuid: 'detail-billet-inst-002',
      status: 'UNAVAILABLE',
      paymentMethod: 'BILLET',
      number: 2,
      maxPaymentDate: '2025-10-12T03:00:00.000Z',
      dueDate: '2025-10-12T03:00:00.000Z',
      value: 400.0,
      hidePaymentDueDate: false,
      isCurrent: false,
      isFirstUnpaid: false,
      isNext: true,
    },
    {
      id: 8817700576,
      uuid: 'detail-billet-inst-003',
      status: 'UNAVAILABLE',
      paymentMethod: 'BILLET',
      number: 3,
      maxPaymentDate: '2025-11-12T03:00:00.000Z',
      dueDate: '2025-11-12T03:00:00.000Z',
      value: 400.0,
      hidePaymentDueDate: false,
      isCurrent: false,
      isFirstUnpaid: false,
      isNext: false,
    },
    {
      id: 8817700577,
      uuid: 'detail-billet-inst-004',
      status: 'UNAVAILABLE',
      paymentMethod: 'BILLET',
      number: 4,
      maxPaymentDate: '2025-12-12T03:00:00.000Z',
      dueDate: '2025-12-12T03:00:00.000Z',
      value: 400.0,
      hidePaymentDueDate: false,
      isCurrent: false,
      isFirstUnpaid: false,
      isNext: false,
    },
    {
      id: 8817700578,
      uuid: 'detail-billet-inst-005',
      status: 'UNAVAILABLE',
      paymentMethod: 'BILLET',
      number: 5,
      maxPaymentDate: '2026-01-12T03:00:00.000Z',
      dueDate: '2026-01-12T03:00:00.000Z',
      value: 400.0,
      hidePaymentDueDate: false,
      isCurrent: false,
      isFirstUnpaid: false,
      isNext: false,
    },
  ],
  bills: [
    {
      id: 'DEBT-001',
      date: '2024-06-15',
      value: 3500.0,
      description: 'Fatura vencida',
      product: 'Cartão de Crédito',
      agingDays: 300,
      origin: 'Cartão de Crédito',
      contract: '020250909',
      interestPercentage: 10.0,
    },
  ],
  PRA: {
    range: ['2025-09-09', '2025-09-30'],
  },
};

export const mockAgreementDetailPix: ViewmodelAgreement = {
  ...mockAgreementDetail,
  id: 25855002,
  uuid: '550e8400-e29b-41d4-a716-446655440002',
  contract: 'NU789654123',
  product: 'Empréstimo Pessoal',
  creditor: {
    slug: 'nubank',
    name: 'Nubank',
    logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/8d256242a2/nubank.svg',
    systemSlug: 'nubank',
  },
  paymentMethods: { firstInstallment: 'PIX', default: 'PIX' },
  installments: mockAgreementDetail.installments.map((inst) => ({ ...inst, paymentMethod: 'PIX' as const })),
};

export const mockAgreementDetailCancelled: ViewmodelAgreement = {
  ...mockAgreementDetail,
  id: 25855005,
  uuid: '550e8400-e29b-41d4-a716-446655440005',
  status: 'CANCELLED',
  isCancellable: false,
  installments: mockAgreementDetail.installments.map((inst) => ({ ...inst, status: 'UNAVAILABLE' as const })),
};

export const mockAgreementDetailPaid: ViewmodelAgreement = {
  ...mockAgreementDetail,
  id: 25855006,
  uuid: '550e8400-e29b-41d4-a716-446655440006',
  status: 'PAID',
  isCancellable: false,
  installments: mockAgreementDetail.installments.map((inst) => ({ ...inst, status: 'PAID' as const })),
};
